import React from "react";

/**
 * Sentiment label → coloured dot. Used in admin lists.
 * Labels: positive | neutral | negative | urgent (or null/undefined).
 */
const STYLES = {
    positive: { dot: "bg-emerald-500", ring: "ring-emerald-200", label: "Positive" },
    neutral: { dot: "bg-zinc-400", ring: "ring-zinc-200", label: "Neutral" },
    negative: { dot: "bg-amber-500", ring: "ring-amber-200", label: "Negative" },
    urgent: { dot: "bg-rose-500", ring: "ring-rose-300 animate-pulse", label: "Urgent" },
};

const SentimentDot = ({ sentiment, showLabel = false, size = "md" }) => {
    const lab = sentiment?.label || null;
    const cfg = STYLES[lab] || { dot: "bg-zinc-200", ring: "ring-zinc-100", label: "Unknown" };
    const dim = size === "sm" ? "h-2 w-2" : size === "lg" ? "h-3 w-3" : "h-2.5 w-2.5";
    return (
        <span
            className="inline-flex items-center gap-1.5"
            title={sentiment?.reasoning || cfg.label}
            data-testid={`sentiment-dot-${lab || "unknown"}`}
        >
            <span className={`inline-block rounded-full ring-2 ${dim} ${cfg.dot} ${cfg.ring}`} />
            {showLabel && <span className="text-xs font-medium text-zinc-600">{cfg.label}</span>}
        </span>
    );
};

export default SentimentDot;
